import {PosCardTerminalContainerModel} from '../../../../../../models/aggregates/erp/pos/pos-card-terminal-container.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class PosCardTerminalService extends BaseApiTemplateService<PosCardTerminalContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'pos-card-terminals/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'pos-card-terminals/backoffice-ep';
    this.httpClient = http;
  }
}
